<template>
    <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
        <div class="lang-select-container">
            <i class="el-icon-location-information" />
            <span class="current-lang">{{ currentLanguageText }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :disabled="language === 'zh'" command="zh">
                <span :class="{ 'active-lang': language === 'zh' }">中文</span>
            </el-dropdown-item>
            <el-dropdown-item :disabled="language === 'en'" command="en">
                <span :class="{ 'active-lang': language === 'en' }">English</span>
            </el-dropdown-item>            
            <el-dropdown-item :disabled="language === 'ko'" command="ko">
                <span :class="{ 'active-lang': language === 'ko' }">한국어</span>
            </el-dropdown-item>
            <!--
            <el-dropdown-item :disabled="language === 'ja'" command="ja">Japanese</el-dropdown-item>
            -->
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
export default {
    name: "LangSelect",
    computed: {
        language() {
            return this.$store.getters.language
        },
        currentLanguageText() {
            const langMap = {
                'zh': '中文',
                'en': 'English',
                'ko': '한국어',
                'ja': 'Japanese'
            }
            return langMap[this.language] || '中文'
        },
    },
    data() {
        return {
        }
    },
    created() {

    },
    watch: {

    },
    methods: {
        handleSetLanguage(lang) {
            console.log('lang:', lang)
            this.$i18n.locale = lang;
            this.$store.dispatch('app/setLanguage', lang)
            this.$message.success('switch language success')
        }
    }
}
</script>

<style scoped>
.lang-select-container {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.3s;
}

.lang-select-container:hover {
    background-color: #b3b5b7;
}

.current-lang {
    margin-left: 6px;
    font-size: 14px;
    color: #606266;
    font-weight: 500;
    /* width: 200px; */
}

.active-lang {
    color: #409EFF;
    font-weight: 600;
}

.international {
    margin-right: 10px;
}

/* 下拉菜单样式优化 */
::deep(.el-dropdown-menu__item) {
    padding: 8px 20px;
}

::deep(.el-dropdown-menu__item:not(.is-disabled):hover) {
    background-color: #f5f7fa;
    color: #606266;
}
</style>

<style>
</style>